import { Link } from "@/lib/nav";

import Banner from "@buildpy/ui/banner";
import { DEMO_PATH } from "@buildpy/core/modules/demo/routes";

// 데모 화면 맨 위 띠 — 가상 현장이라는 것과 데모 첫 화면으로 돌아가는 길.
const DemoBanner = () => (
  <Banner className="print-hide rounded-none border-x-0 border-t-0 text-center" tone="warning">
    데모 화면입니다 · 가상의 현장이라 눌러도 저장되지 않습니다 ·{" "}
    <Link className="font-medium underline underline-offset-2" href={DEMO_PATH.home}>
      데모 목록
    </Link>
  </Banner>
);

export default DemoBanner;
